module.exports = __webpack_public_path__ + "static/logo-ff249c4299fce08e677e5b03a74404b8.svg";